import invariant from "tiny-invariant"

import { toggleConnectAgentStatus } from "./agent-status-hooks"
import { persistenceService } from "./persistence"
import { AgentState } from "./state-types"

type Props = { agentRef: React.RefObject<connect.Agent | null> }

export function createSideEffectActions({ agentRef }: Props) {
  const actions = {
    // Enter the custom agent status of `PseudoACW` to make the agent non routable (no incoming calls)
    enterPseudoACW: ({ context }: { context: AgentState }) => {
      invariant(agentRef.current, "No agent provided")
      persistenceService.enterPseudoACW()
      if (context.taskMeta?.origin === "v2") {
        toggleConnectAgentStatus(agentRef.current, "pseudo_acw", {
          enqueueNextState: true,
        })
      }
    },
  }

  return actions
}
